<dx-date-range-box
  class="date-range-box"
  startDateLabel="Début"
  endDateLabel="Fin"
  [showClearButton]="true"
  (onValueChanged)="onValueChanged($event)"
  width="250"
>
</dx-date-range-box>
